/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/jsx-no-useless-fragment */
import React, { useEffect } from 'react';
import sanitizeHtml from 'sanitize-html';
import { Button } from '../Button';
import styles from './AdvertisingBanner.module.scss';
export const AdvertisingBanner = ({ title, heading, text, imageUrl = null, ctaText = null, handleCtaClick = () => { }, contactDetails = null, onLoad = null, }) => {
    useEffect(() => {
        if (onLoad) {
            onLoad();
        }
    }, []);
    return (<>
      <div className={styles.advertisingBanner}>
        <div className={styles.body}>
          {heading && <h3>{heading}</h3>}
          <div className={styles.bannerContent}>
            {title && <h2>{title}</h2>}
            <div>
              {text && (<p className={styles.text} dangerouslySetInnerHTML={{ __html: sanitizeHtml(text) }}/>)}
            </div>

            {ctaText && (<Button onClick={handleCtaClick} className={styles.button}>
                {ctaText}
                <img src='https://www.haven.com/assets/icons/chevron-b-right.svg' alt='Chevron right'/>
              </Button>)}
          </div>
        </div>

        <div className={styles.contactInfo}>
          <div className={styles.imageText}>
            {imageUrl && <img className={styles.image} src={imageUrl} alt={title}/>}
            <div className={styles.data}>
              {(contactDetails === null || contactDetails === void 0 ? void 0 : contactDetails.name) && (<p className={styles.imageHeading}>{contactDetails === null || contactDetails === void 0 ? void 0 : contactDetails.name}</p>)}
              {(contactDetails === null || contactDetails === void 0 ? void 0 : contactDetails.jobTitle) && (<p className={styles.jobTitle}>{contactDetails === null || contactDetails === void 0 ? void 0 : contactDetails.jobTitle}</p>)}
              {(contactDetails === null || contactDetails === void 0 ? void 0 : contactDetails.phone) && (<a href={`tel:${contactDetails === null || contactDetails === void 0 ? void 0 : contactDetails.phone}`}>{contactDetails === null || contactDetails === void 0 ? void 0 : contactDetails.phone}</a>)}
              {(contactDetails === null || contactDetails === void 0 ? void 0 : contactDetails.email) && (<a href={`mailto:${contactDetails === null || contactDetails === void 0 ? void 0 : contactDetails.email}`}>{contactDetails === null || contactDetails === void 0 ? void 0 : contactDetails.email}</a>)}
            </div>
          </div>
        </div>
      </div>
    </>);
};
